<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import Table from "@/components/standard/IdentificationPlanning/components/PlanningTable2"
import responsabilityPlan from "@/services/standards/responsabilityPlan/responsabilityPlanAPI"
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI"
import newScoresAPI from "../../../services/newScores/newScoresAPI"
import ItemAPI from "@/services/items/itemsAPI";
import Swal from "sweetalert2";
import { sendNotification } from "@/utils/helpers/notification"

/**
 * Form elements component
 */
export default {
  page: {
    title: "2.4.1 Plan de trabajo anual",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Table,
    Layout,
    Style,
    PageHeader,
  },
  data() {

    return {
      title: "2.4.1 Plan de trabajo anual",
      items: [
        {
          text: "Estandares",
          href: "/forms/estandares",
        },
        {
          text: "Plan que identifica objetivos, metas",
        },
        {
          text: "Editar",
          active: true,
        },
      ],

      lista: [],

      file: null,
      loading: true,
      guardando: false,
      item: null,

      planning: {
        file: "datos",
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },

      company: this.$store.getters["company/getCompany"] || null,
      itemData: null,
      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,

    };
  },
  methods: {

    getItemData() {
      ItemAPI.getItems(15)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;
        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"].company_classification_id || null;
          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 15)
        .then(response => {
          this.item = response || null
        })
        .catch(error => {
          console.log(error)
        })
    },

    /**
         * This method is used to send notification to SST user and SST company.
         * The sendNotification method import is required.
         * @param {Number} messageID - The message ID that will be associated to notification.
         * @param {Number} itemID - The item ID that will be associated to notification.
         * @param {Boolean} user - The user that will e associated to notification.
         * @return {Boolean} True if the notification is sent, false if not.
         */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(company.id, user ? company.id_diseno_sso : null, messageID, itemID);
    },

    /**
    * This method is used to knows if the user has the permission indicated
    * @param {String} name The name of the permission
    * @param {Array} roles the roles that permitted to access the action 
    * @returns {Boolean} true if the user has the permission indicated or false if no
    */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role ? this.$store.state.auth.info.role : null
      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false
        } // Close if the roles arrays is not empty
        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8
        } // Close if the roles arrays is empty
        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions
        // Know if the user has the permission indicated
        const enabled = permissions.find(permission => permission.name === name)
        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false
      } // Close if the user is logged
      // If the user is not logged
      else {
        return false
      } // Close else the user is not logged
    },

    /**
   * This method is used to redirect to the page indicated
   * @param {String} page The page to redirect
   */
    goPage(page) {
      window.location.href = page
    },

    getFile(file) {
      const name = file.split('/')
      return name[name.length - 1]
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    async uploadDocument() {
      try {
        let url = "";
        let name = '';

        if (this.file === null) {
          name = this.getFile(this.planning.file)
        } else {
          name = this.file.name
        }

        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.company.nit}/2.4.1/${this.$route.params.id}/${name}`;
        } else {
          url = `sst-prod/${this.company.nit}/2.4.1/${this.$route.params.id}/${name}`;
        }

        if (this.file === null) {
          return true;
        } else {
          const result = await uploadDocument(url, this.file);
          if (result) {
            this.planning.file = `${process.env.VUE_APP_BUCKET}/${url}`;
            return true;
          } else return false;
        }
      } catch (error) {
        console.log(error);
      }
    },

    getObjetive() {
      responsabilityPlan.getID(this.$route.params.id)
        .then((response) => {
          this.planning = {
            file: response.Responsibility_plan.link_file,
            companies_id: response.Responsibility_plan.companies_id
          };
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async update() {
      this.guardando = true
      this.loading1 = true
      let document = await this.uploadDocument();
      if (document) {
        responsabilityPlan.update(this.$route.params.id, {
          link_file: this.planning.file,
          companies_id: this.planning.companies_id,
        })
          .then((response) => {
            const itemChange = {
              companies_id: this.companyID,
              item_id: 15,
              status: 'Pendiente',
            };
            newScoresAPI.calculateScores(itemChange)
              .then((response) => {
                Swal.fire({
                  title: "¡Informacion actualizada con éxito!",
                  text: "¡Informacion actualizada con éxito!",
                  icon: "success",
                  type: "success",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                this.$router.go(-1);
              })
              .catch((error) => {
                this.loading1 = false
                setTimeout(() => {
                  Swal.fire({
                    title: "Error",
                    text: "¡No se ha podido registrar!",
                    icon: "error",
                    type: "error",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                }, 1000);
                console.log(error);
              });
          });
      } else {
        this.loading1 = false
        setTimeout(() => {
          Swal.fire({
            title: "¡No se ha podido actualizar!",
            text: "¡No se ha podido actualizar!",
            icon: "warning",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          window.location.reload()
        }, 3000)
      }
    },

    async print() {
      try {
        const url = 'https://idmrnd3cibfs.compat.objectstorage.us-ashburn-1.oraclecloud.com/e-mision-sst/standards/PLAN_DE_TRABAJO_SST_2026.xlsx'
        window.location.href = url
      } catch (error) {
        console.log(error);
      }
    },

    goBack() {
      this.$router.go(-1);
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

    fetch() {
      this.$refs.paginator.query();
    },

  },

  mounted() {
    this.getItems()
    this.getItemData();
    this.getObjetive()
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div v-if="!loading">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-6">
                  <h3> <button v-b-modal.modal-lg class="header-title background-modal ">
                      Modo de verificación <i class="mdi mdi-eye"></i>
                    </button> </h3>

                  <b-modal id="modal-lg" size="lg" title="Modo verificación" title-class="font-18" hide-footer>...
                  </b-modal>

                </div>

                <div class="col-6 text-right m-b-0">
                  <button :disabled="!allowAccess()" @click="print" class="btn btn-primary mx-1" id="tooltip">
                    <span class="btn-label"> <i class="bx bx-download"></i></span> Descargar plan de trabajo SG-SST
                  </button>

                  <b-tooltip target="tooltip" placement="left">
                    Descargar plan de trabajo SG-SST
                  </b-tooltip>
                </div>

              </div>

              <div class="row">
                <div class="col-6">
                </div>

              </div>

              <form class="form-group" @submit.prevent="update">
                <div class="form-row pt-3">

                  <b-form-group class="col-md-12 px-2" label="Subir archivo" label-for="file">
                    <b-form-file :disabled="!allowAccess()" required type="file" id="file" ref="file" name="file"
                      browse-text="Buscar"
                      :placeholder="planning.file ? getFile(planning.file) : `Selecciona un archivo...`"
                      drop-placeholder="Suelta acá..." v-model="file" @change="uploadFile" v-on:change="uploadFile"
                      accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                    </b-form-file>
                  </b-form-group>

                </div>

                <div class="form-group text-right m-b-0">
                  <button :disabled="guardando" type="submit" class="btn btn-primary">
                    Guardar
                  </button>
                  <button type="button" class="btn btn-secondary mx-1" @click="goBack">
                    Cancelar
                  </button>
                </div>

              </form>
            </div>
          </div>

        </div>

      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>